// Meta ピクセル（Facebook / Instagram 広告の計測）。
//
// Metaが配布するスニペットは <head> に直貼りする前提で、読み込み直後に
// PageView を1回送る。SPAではルート変更でページが再読み込みされないため、
// そのまま貼ると初回の1ページしか計上されない。
// GA4・HubSpot と同じく、初期化と送信を分けて usePageTracking から叩く。
//
// 目的は最適化よりも、リターゲティングの母集団を貯めること。
// ピクセルは後から入れても過去の訪問者を遡れないため、配信前に入れておく。

const PIXEL_ID = "1723903083072408";

let initialized = false;

// Metaの公式スニペットと同じことをやる。
//
// fbq のスタブを先に置いてから fbevents.js を読み込むので、読み込み完了前に
// 呼んだ track も queue に積まれて取りこぼさない。公式は arguments を使うが、
// ここでは同じ動きになる rest 引数にしている（配列でも fbevents 側は同様に扱う）。
const loadPixelScript = () => {
  if (window.fbq) return;

  function fbq(...args) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args);
    } else {
      fbq.queue.push(args);
    }
  }

  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];

  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  const first = document.getElementsByTagName("script")[0];
  first.parentNode.insertBefore(script, first);
};

export const initMetaPixel = () => {
  if (initialized || typeof window === "undefined") return;
  loadPixelScript();
  // 初回の PageView は usePageTracking 側から送る。
  // ここで送ると、初回だけ2回計上される。
  window.fbq("init", PIXEL_ID);
  initialized = true;
};

export const sendMetaPageView = () => {
  if (!initialized || !window.fbq) return;
  window.fbq("track", "PageView");
};

// フォーム送信の完了時に1回だけ送る。
// Metaの標準イベントのうち、資料請求はこれが定義に合う。
// eventName を渡すと差し替えられる（診断・相談で分けたくなったとき用）。
export const sendMetaLead = (params, eventName = "Lead") => {
  if (!initialized || !window.fbq) return;
  window.fbq("track", eventName, params);
};
